export interface LegalEntityConstructor {
  id: number
  uuid: string
  name: string
  baseCurrencyId: number
  baseCurrencyName: string
  country: string
  externalId: string
  active: boolean
  createdAt: Date
  updatedAt: Date
  locationCount: number
  inboxEmailAddress: string
}

export class LegalEntity {
  readonly id: number
  readonly uuid: string
  readonly name: string
  readonly baseCurrencyId: number
  readonly baseCurrencyName: string
  readonly country: string
  readonly externalId: string
  readonly active: boolean
  readonly createdAt: Date
  readonly updatedAt: Date
  readonly locationCount: number
  readonly inboxEmailAddress: string

  constructor(data: LegalEntityConstructor) {
    this.id = data.id
    this.uuid = data.uuid
    this.name = data.name
    this.baseCurrencyId = data.baseCurrencyId
    this.baseCurrencyName = data.baseCurrencyName
    this.country = data.country
    this.externalId = data.externalId
    this.active = data.active
    this.createdAt = data.createdAt
    this.updatedAt = data.updatedAt
    this.locationCount = data.locationCount
    this.inboxEmailAddress = data.inboxEmailAddress
  }
}
